import { useState, useEffect, useRef } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import moment from "moment";
import Search from "../../assets/search.svg";
import { mq } from "../responsive";
import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock";

import People from "./People";
import DatePicker from "./DatePicker";

import { List, CheckBox } from "../UI";
import { Paragraph, Heading } from "../UI/Typoraphy";

const infoItem = {
  color: "#333",
  fontSize: "1.5rem",
  lineHeight: "3rem",
  cursor: "pointer",

  width: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  backgroundColor: "transparent",

  "&:not(:first-of-type)": {
    borderStyle: "solid",
    borderColor: "#E7EDF3",
    borderWidth: "0 0 0 1px",
  },

  [mq.md]: {
    fontWeight: 400,
    width: "unset",
    fontSize: "2rem",
    borderStyle: "solid",
    borderColor: "#E7EDF3",
    borderWidth: "0 0 0 1px",
    padding: "0 1rem",
    textAlign: "left",
  },
};

const locations = [
  { name: "Tien Giang", types: [""] },
  { name: "Ben Tre", types: [""] },
  { name: "Sai Gon", types: [""] },
  { name: "Soc Trang", types: [""] },
];

const SearchBar = ({ style, focusStyle, onScroll, bordered }) => {
  const [focus, setFocus] = useState(false);

  const [people, setPeople] = useState([1, 0]);
  const [date, setDate] = useState(moment(Date.now()).format("Do MM"));
  const [location, setLocation] = useState("");
  const [types, setTypes] = useState([]);

  const search = useRef();

  useEffect(() => {
    if (search.current) {
      const target = search.current;
      const handleClickOutside = (event) => {
        if (target && !target.contains(event.target)) setFocus(false);
      };

      window.addEventListener("mousedown", handleClickOutside);

      return () => {
        window.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [search.current]);

  useEffect(() => {
    if (focus && window.innerWidth < 768) {
      disableBodyScroll(document.body);

      return () => {
        enableBodyScroll(document.body);
      };
    }
  }, [focus]);

  const handleInputChange = (e) => {
    let s = e.target.value.trim();
    setLocation(s);
  };

  return (
    <div
      css={{
        width: "100%",
        margin: "0",
        borderRadius: "3rem",
        padding: "0 4rem 0",
        position: "relative",
        transition: "all 0.2s ease-in-out",
        backgroundColor: "#ffffff",

        ...(focus
          ? {
              position: "fixed",
              left: 0,
              top: "16rem",
              overflowY: "auto",
              height: "calc(100vh - 14rem)",
              zIndex: 2,
              padding: "0 4rem 2rem",
            }
          : {}),

        [mq.md]: {
          position: "relative",
          top: "unset",
          left: "unset",
          height: "fit-content",
          zIndex: "unset",
          maxHeight: "50%",
          overflowY: "visible",
          padding: 0,
          boxShadow: focus ? "0 6px 14px rgba(0, 0, 0, 0.08)" : "none",
        },
      }}
      ref={search}
    >
      <div
        css={{
          position: "sticky",
          top: 0,

          ...(focus
            ? {
                "&:before": {
                  content: `""`,
                  position: "absolute",
                  height: "12rem",
                  top: 0,
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,1) 60%, rgba(255,255,255,0.6) 80%, rgba(255,255,255,0) 100%)",
                  zIndex: -1,
                  width: "100%",
                },
              }
            : {}),

          [mq.md]: {
            position: "relative",
          },
        }}
      >
        <img
          src={Search}
          alt="search"
          css={{
            position: "absolute",
            left: "2.5rem",
            top: "50%",
            transform: "translateY(-50%)",
            width: "2rem",

            [mq.md]: {
              left: "4rem",
            },
          }}
        />
        <input
          onFocus={() => setFocus(true)}
          autoComplete="off"
          type="text"
          name="location"
          id="location"
          value={location}
          onChange={handleInputChange}
          placeholder="Where are you going?"
          css={{
            padding: "1.5rem 2rem 1.5rem 6rem",
            borderRadius: "3rem",
            border: "none",
            boxShadow: "0 6px 14px rgba(0, 0, 0, 0.08)",
            outline: "none",
            fontSize: "2rem",
            width: "100%",
            lineHeight: "3rem",

            [mq.md]: {
              boxShadow: "none",
              padding: "1.5rem 2rem 1.5rem 8rem",
              border: bordered ? "1px solid #999999" : "none",
            },
          }}
        />
      </div>
      <div
        css={{
          display: focus ? "block" : "none",

          [mq.md]: {
            padding: "0 2rem 1rem",
          },
        }}
      >
        <Heading level={2} style={{ marginTop: "4rem" }}>
          Explore now
        </Heading>
        <CheckBox
          onChange={(value) => setTypes(value)}
          display="flex"
          overflowX="auto"
          options={[
            { label: "All", value: "" },
            { label: "Top Experiences", value: "Top Experiences" },
            { label: "Food and Beverage", value: "Food and Beverage" },
            { label: "Outdoor Acitivites", value: "Outdoor Acitivites" },
            { label: "Artisan Villages", value: "Artisan Villages" },
            { label: "Seasonal Festival", value: "Seasonal Festival" },
          ]}
        />
        <hr css={{ margin: "2rem 0" }} />
        <List heading={{ content: "Popular Destinations", level: 2 }}>
          {locations.map((item, index) => (
            <List.Item
              style={{ padding: "1rem 0" }}
              key={index}
              onClick={() => {
                setLocation(item.name);
                setFocus(false);
              }}
            >
              <Paragraph style={{ color: "#939DA9", cursor: "pointer" }}>
                <i
                  className="fas fa-map-marker-alt"
                  style={{ marginRight: "1rem", color: "#333" }}
                ></i>
                {item.name}
              </Paragraph>
            </List.Item>
          ))}
        </List>
      </div>
      <div
        css={{
          display: focus ? "none" : "flex",
          padding: "1.5rem 1rem",
          borderRadius: "3rem",
          margin: "2rem 0",
          backgroundColor: "transparent",
          boxShadow: "0 6px 14px rgba(0, 0, 0, 0.08)",

          [mq.md]: {
            boxShadow: "none",
            width: "fit-content",
            position: "absolute",
            fontWeight: 500,
            display: "flex",
            top: 0,
            right: 0,
            margin: 0,
          },
        }}
      >
        <People
          style={infoItem}
          people={people}
          onChange={(value) => setPeople(value)}
        />
        <DatePicker style={infoItem} onChange={(value) => setDate(value)} />
      </div>
    </div>
  );
};

export default SearchBar;
